/**
 */
define('constant/appmng/app.constant',[], function () {
    var obj ={
        prodType: {
            "1": "移动应用",
            "2": "智慧屏应用",
            "3": "手柄游戏应用",
            "4": "路由器应用",
            "5": "HiLink产品",
            "6": "HiLink 模组",
            "7": "服务器应用",
            "8": "华为VR应用",
            "9": "手表应用",
            "14": "主题",
            "15": "壁纸",
            "17": "字体",
            "18": "杂志锁屏图片",
            "19": "快应用",
            "20": "动态壁纸",
            "21": "AppTouch应用",
            "22": "IOS移动应用",
            "23": "智慧屏快应用",
            "27": "车机应用",
            "28": "车机快应用",
            "42": "PC快应用",
            "app": 1,
            "tv": 2,
            "vr": 8,
            "hwwatch": 9,
            "freeInstall": 19,
            "26": "ePay",
            "29": "Lite OS手表应用",
            "30": "云游戏",
            "40": "鸿蒙应用"
        },

        appAdapterType: [{key: 4, value: '手机', flag: true},
            {key: 5, value: '平板', flag: false},
            {key: 7, value: '华为手表', flag: false},
            {key: 8, value: 'TV', flag: false},
            {key: 9, value: '路由器', flag: false}
        ],
        tvAdapterType: [{key: 1, value: '荣耀立方(路由器)', flag: false},
            {key: 3, value: '荣耀盒子/华为盒子', flag: false}
        ],
        webAppType: [{key: '1,2', value: '是否支持服务器应用', flag: false}
        ],
        tvRemoteControl: [{key: 1, value: '遥控器', flag: false},
            {key: 2, value: '手柄', flag: false}
        ],
        productName: {
            "app": "移动应用",
            "tv": "智慧屏应用",
            "hwwatch": "手表应用",
            "vr": "华为VR应用"
        },
        productNameType: {
            "app": "1",
            "tv": "2",
            "hwwatch": "9",
            "vr": "8"
        },
        appNetType: {
            1: "单机游戏",
            2: "网络游戏"
        },
        parentTypeSelected: {
            key: "13", value: "应用"
        },
        languageAppSelected: {
            key: "zh-CN", value: "简体中文"
        },

        languageVrSelected: {
            key: "zh-CN", value: "简体中文"
        },

        languageTVSelected: {
            key: "zh-CN",
            value: "简体中文"
        },
        languageWatchSelected: {
            key: "zh-CN",
            value: "简体中文"
        },
        languageWallPaperSelected: {
            key: "zh-CN",
            value: "简体中文"
        },
        languageWebAppSelected: {
            key: "zh-CN",
            value: "简体中文"
        },
        prodState: {
            "0": "草稿",
            "1": "审核中（不用）",
            "2": "已处理",
            "3": "转移待审核",
            "4": "转移中",
            "5": "已删除"
        },
        cfpTaskState: {
            "CREATIVE PENDING": "草稿",
            "AUDIT PENDING": "审核中",
            "REJECTED": "不通过",
            "RUN": "执行",
            "DONE": "完成",
            "CANCELED": "已取消"
        },
        cfpTaskStateComBox: [
            {id: "CREATIVE PENDING", name: "草稿"},
            {id: "AUDIT PENDING", name: "审核中"},
            {id: "REJECTED", name: "不通过"},
            {id: "RUN", name: "执行"},
            {id: "DONE", name: "完成"},
            {id: "CANCELED", name: "已取消"}
        ],
        selectFile: "选择文件",
        secureUrlList: [
            {
                key: "url1",
                urlName: "安全URL1",
                value: "",
                mustFlag: true
            },
            {
                key: "url2",
                urlName: "安全URL2",
                value: "",
                mustFlag: false
            },
            {
                key: "url3",
                urlName: "安全URL3",
                value: "",
                mustFlag: false
            },
            {
                key: "url4",
                urlName: "安全URL4",
                value: "",
                mustFlag: false
            },
            {
                key: "url5",
                urlName: "安全URL5",
                value: "",
                mustFlag: false
            }
        ],
        appClaims: {
            "emptyApkMinSize": 4,
            "emptyApkMaxSize": 15
        },
        prodTypeFilter: {
            1: 'app',
            2: 'tv',
            5: 'hiLinkPro',
            6: 'hiLinkModel',
            7: 'webApp',
            8: 'vr',
            9: 'hwwatch',
            14: 'theme',
            15: 'wallpaper',
            16: 'server',
            17: 'font',
            18: 'screenLock',
            19: 'freeInstall'
        },
        openStateFilter: {0: '未开通', 1: '开通待审核', 2: '开通审核不通过', 3: '已开通', 4: '已关闭', 5: '--', 6: '开通中'},
        serviceStateForManagerFilter: {
            '101': '已上架',
            '102': '已上架',
            '103': '已上架',
            '104': '已上架',
            '105': '已上架',
            '62': '待上架',
            '-999': '审核中',
            '999': '审核中',
            '-995': '升级中',
            '99999': '申请下架',
            '0': '不通过',
            '2': '不通过',
            '-1': '不通过',
            '1': '已下架',
            '-2': '已下架',
            '9998': '草稿',
            '300': '不通过',
            '301': '不通过'
        },
        growServices: [3, 4, 5, 24, 30, 40, 53],//分发服务，也是推广服务
        defaultProductGrayIconFilter: {
            '1': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/mob-application.png',
            '2': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/tv-application.png',
            '3': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/handle-application.png',
            '4': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/handle-application.png',
            '5': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/hilink-products.png',
            '6': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/hilink-module.png',
            '7': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/server_gray.png',
            '8': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/hw_vr_g.png',
            '9': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/watch_s_g.png',
            '14': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/theme.png',
            '15': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/wallpaper.png',
            '16': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/server.png',
            '17': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/font.png',
            '18': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/lockscreen-wallpager.png',
            '19': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/freeInstall.png',
            '20': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/wall_paper.png',
            '21': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/mob-application.png',
            '22': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/IOS.png',
            '23': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/tv-application.png',
            '26': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/ePay.png',
            '27': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/car-phone.png',
            '28': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/car-phone-q.png',
            '29': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/lite-os-application.png',
            '30': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/cloud-gaming.png',
            '40': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/harmonyOS-application.png',
            '42': 'vendors/ucd/resources/default/images-asyn/iconset/x40/gray/pc-app-q.png'
        },//默认图标 vendors/ucd/resources/default/images-asyn/products/mob-application.png

        serviceItemToAgreement: {
            8: [{agrType: 1005, country: 'cn', count: 1}, {agrType: 1067, country: 'cn', count: 1}, {
                agrType: 1003,
                country: 'cn',
                count: 1
            }],
            32: [{agrType: 1067, country: 'cn', count: 1}],
            33: [{agrType: 1067, country: 'cn', count: 1}, {agrType: 1013, country: 'cn', count: 1}],
            40: [{agrType: 1067, country: 'cn', count: 1}],
            52: [{agrType: 1067, country: 'cn', count: 1}]
        },
        serviceItemToAgreementType: {
            52: ['1067'],
            8: ['1005', '1067', '1003'],
            32: ['1067'],
            59: ['1008'],
            33: ['1013', '1067'],
            45: ['1012'],
            43: ['1020'],
            40: ['1067']
        },
        returnCode: {
            1000000006: '导出数据过大,请分批导出。',
            1000000001: window.syserrorMsg,
            1: '参数错误',
            2: '关键词重复，请更换成其他关键词。',
            3: '请先从否定关键词列表中删除此关键词再添加。'

        }
    };
    obj.serviceItemToAgreement[sysParamCfg.harmonyOsCardID] =[{agrType: 1195, country: 'cn', count: 1},{agrType: 1067, country: 'cn', count: 1}];
    obj.serviceItemToAgreementType[sysParamCfg.harmonyOsCardID] =['1195','1067'];
    return obj;
});

